import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import SectionHeader from '../components/SectionHeader';
import { blogPosts, BlogCard, BlogCardArt } from '../components/BlogPosts';
import '../styles/pages/blog.css';

function Blog() {
  const [featured, ...rest] = blogPosts;
  const topics = ['AI automation', 'Procurement', 'Privacy', 'Operations'];

  return (
    <>
      <PageHero
        className="blog-index-hero"
        eyebrow="Blog"
        title={<>Moneli <em>Insights</em></>}
        lead="Practical guides on AI automation, procurement, privacy, and operations — built for teams that need results, not hype."
        crumbs={[{ to: '/', label: 'Home' }, { label: 'Blog' }]}
      >
        <ul className="blog-topics" aria-label="Topics">
          {topics.map((t) => <li key={t} className="pill">{t}</li>)}
          <li className="blog-topics__count">{blogPosts.length} articles</li>
        </ul>
      </PageHero>

      <section className="section section--dark grain blog-featured" aria-labelledby="blog-featured-title">
        <div className="container">
          <p className="eyebrow" data-reveal><span className="eyebrow__num">Latest</span>Featured article</p>
          <article className="blog-feature stretch-host" data-cursor="Read">
            <div className="blog-feature__art" data-reveal-img>
              <div data-parallax="0.06" className="blog-feature__art-inner">
                <BlogCardArt slug={featured.slug} />
              </div>
            </div>
            <div className="blog-feature__body">
              <p className="blog-card__meta" data-reveal>
                <span className="blog-chip">{featured.category}</span>
                <time dateTime={featured.iso}>{featured.date}</time>
                <span aria-hidden="true" className="blog-card__dot" />
                <span>{featured.read} min read</span>
              </p>
              <h2 className="blog-feature__title" id="blog-featured-title" data-reveal>
                <Link to={`/blog/${featured.slug}`} className="blog-card__link link-stretch">{featured.title}</Link>
              </h2>
              <p className="blog-feature__excerpt" data-reveal data-delay="0.15">{featured.excerpt}</p>
              <span className="btn btn-primary btn-lg blog-feature__btn" aria-hidden="true" data-reveal data-delay="0.25">
                Read Article <i className="fa-solid fa-arrow-right" />
              </span>
            </div>
          </article>
        </div>
      </section>

      <section className="section section--light blog-list" aria-labelledby="blog-list-title">
        <div className="container">
          <SectionHeader
            eyebrow="All articles"
            title={<>More <em>articles</em></>}
            id="blog-list-title"
          />
          <div className="grid-3 blog-grid" data-reveal-stagger>
            {rest.map((post) => <BlogCard key={post.slug} post={post} />)}
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog;
